export enum CourseStatus {
    ACTIVE = 'ACTIVE',
}